<template>
  <div class="box-second">
    <p class="title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>危大监测</el-breadcrumb-item>
        <el-breadcrumb-item>吊钩可视化</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="box-main">
      <div class="monitor-list">
        <div class="item-icon" @click="toLeft">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="list-ul">
          <div style="width:100%;height:100%;overflow:auto;position: relative;">
            <ul style="width: auto;list-style: none;display: inline-flex;" :style="{'left':ulLeft}">
              <li class="list-item" :class="(towerId==item.id?'on':'')" v-for="(item,index) in towerlist" :key="index" @click="changeTower(item)">
                <p class="name nowrap">{{item.name}}</p>
                <p class="stu" v-if="item.connectedStatus=='离线'" style="color:#F56C6C;">离线</p>
                <p class="stu" v-else-if="item.connectedStatus=='正常'" style="color:#67C23A;">在线</p>
                <p class="stu" v-else >{{item.connectedStatus}}</p>
                <p class="code">编号：{{item.deviceId}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="item-icon" @click="toRight">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="box-monitor">
        <div class="box-contain">
            <div class="box-video" id="video-container"></div>
            <div class="box-right">
                <div class="itemR" style="height:100%;">
                    <p class="item_title">操作管理</p>
                    <div class="item_content">
                        <div class="itemR_first">
                            <div class="itemR_first_t">
                                <div class="l_left"></div><span>回放</span><div class="l_right"></div>
                            </div>
                            <p class="itemR_first_n">
                                <span class="itemR_first_n_name">开始时间：</span>
                                <el-date-picker
                                    v-model="starttime"
                                    type="datetime"
                                    placeholder="选择开始时间"
                                    align="right"
                                    value-format="yyyyMMddHHmmss"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </p>
                            <p class="itemR_first_n">
                                <span class="itemR_first_n_name" >结束时间：</span>
                                <el-date-picker
                                    v-model="endtime"
                                    type="datetime"
                                    placeholder="选择结束时间"
                                    align="right"
                                    value-format="yyyyMMddHHmmss"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </p>
                            <div class="layui-btn-container">
                                <el-button type="primary" @click="clickRecordSearch">播放</el-button>
                            </div>
                            <div class="layui-btn-container">
                                <el-button type="warning" v-if="!isLu" @click="startLu">边播边录</el-button>
                                <el-button type="primary" v-if="isLu" disabled>{{transTime(recTime)}}</el-button>
                                <el-button type="danger" v-if="isLu" @click="stopLu">结束录像</el-button>
                            </div>
                        </div>
                        <div class="itemR_first">
                            <div class="itemR_first_t">
                                <div class="l_left"></div><span>云录像</span><div class="l_right"></div>
                            </div>
                            <p class="itemR_first_n" style="text-align: center;justify-content: center;">
                                <el-button type="warning" icon="el-icon-setting" @click="setYunRecTime">录像时间设置</el-button>
                                <el-button type="success" @click="getVideList">录像列表</el-button>
                            </p>
                        </div>
                        <div class="itemR_second" v-if="type!='1'" style="display: block;">
                            <div class="itemR_second_t">
                                <div class="l_left"></div><span>云台</span><div class="l_right"></div>
                            </div>
                            <div class="cn-wrapper opened-nav" id="cn-wrapper" style="margin-bottom: 2vh;display: flex;position: relative;flex-wrap: wrap;justify-content: center;justify-items: center;width: 100%;">
                                <div style="width:102px;height:102px;position: relative;">
                                    <img src="/monitor/img/yun.png" style="width:102px;height:102px;position: relative;" />
                                    <div style="width:30px;height:40px;position: absolute;left: 36px;top: -6px;cursor: pointer;" @mousedown="startYunCtrl(0)" @mouseup="stopYunCtrl(0)"></div>
                                    <div style="width:40px;height:30px;position: absolute;left: 0;top: 36px;cursor: pointer;" @mousedown="startYunCtrl(2)" @mouseup="stopYunCtrl(2)"></div>
                                    <div style="width:30px;height:40px;position: absolute;left: 36px;top: 64px;cursor: pointer;" @mousedown="startYunCtrl(1)" @mouseup="stopYunCtrl(1)"></div>
                                    <div style="width:40px;height:30px;position: absolute;left: 64px;top: 36px;cursor: pointer;" @mousedown="startYunCtrl(3)" @mouseup="stopYunCtrl(3)"></div>
                                </div>
                            </div>
                            <div class="yunCtl">
                                <div class="yunCtl-con">
                                  <el-button type="primary" icon="el-icon-minus" @mousedown.native="startYunCtrl(9)" @mouseup.native="stopYunCtrl(9)"></el-button>
                                  <p class="yunCtl-con-val">变倍</p>
                                  <el-button type="primary" icon="el-icon-plus" @mousedown.native="startYunCtrl(8)" @mouseup.native="stopYunCtrl(8)"></el-button>
                                </div>
                                <div class="yunCtl-con">
                                  <el-button type="primary" @click="stopVoice">关</el-button>
                                  <p class="yunCtl-con-val">声音</p>
                                  <el-button type="primary" @click="startVoice">开</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="itemR_first">
                            <div class="itemR_first_t">
                              <div class="l_left"></div><span>抓图</span><div class="l_right"></div>
                            </div>
                            <p class="itemR_first_n" style="text-align: center;justify-content: center;">
                              <el-button type="primary" @click="capturePicture">抓图</el-button>
                            </p>
                        </div>
                        <div v-if="type!='1'" class="itemR_first recode-itemR">
                            <div class="itemR_first_t">
                              <div class="l_left"></div><span>语音</span><div class="l_right"></div>
                            </div>
                            <div style="width:100%;height:auto;display:flex;justify-content: center;justify-items: center;">
                              <img v-if="isTalk" src="../../assets/image/icon/luing.gif" style="width:5vh;height:5vh;" />
                              <img v-else src="../../assets/image/icon/lu.png" style="width:5vh;height:5vh;" />
                            </div>
                            <p class="itemR_first_n" style="text-align: center;justify-content: center;">
                              <el-button type="success" @click="startTalk">打开对讲机</el-button>
                              <el-button type="warning" v-if="isTalk" @click="stopTalk">关闭对讲机</el-button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- 播放弹出框 -->
    <el-dialog title="历史视频" 
      :visible.sync="videoDialog"
      center 
      :append-to-body="true" 
      :lock-scroll="false"
      style="height:900px;"
      width="60%"
    >
      <div class="videoHead">
          <span>时间：</span>
          <el-date-picker
              v-model="timeRange"
              type="datetimerange"
              :picker-options="pickerOptionsRange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyyMMddHHmmss"
              align="right">
          </el-date-picker>
          <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
      </div>
      <el-table :data="gridData" style="width:100%;height:50vh;" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
          <el-table-column property="fileId" label="ID"></el-table-column>
          <el-table-column property="duration" label="时长"></el-table-column>
          <el-table-column property="fileSize" label="视频大小"></el-table-column>
          <el-table-column property="createTime" label="时间"></el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="dowLoad(scope.row)">下载</el-button>
              </template>
          </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="设置录像时间" 
      :visible.sync="setDialog"
      center 
      :append-to-body="true" 
      :lock-scroll="false"
      width="30%"
    >
      <el-form :model="setForm" :rules="rules" ref="setForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                  v-model="setForm.startTime"
                  type="datetime"
                  value-format="yyyyMMddHHmmss"
                  :picker-options="pickerOptions1"
                  placeholder="选择开始日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                  v-model="setForm.endTime"
                  type="datetime"
                  :picker-options="pickerOptions1"
                  value-format="yyyyMMddHHmmss"
                  placeholder="选择结束日期时间">
              </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="submitForm('setForm')">立即设置</el-button>
              <el-button @click="resetForm('setForm')">重置</el-button>
          </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import util from "../../untils/util";
import myHttp from "../../untils/port";
import base from "../../untils/base";
import  EZUIKit from 'ezuikit-js';
export default {
  data() {
    return {
      groupId: "",
      towerId: "", //当前塔吊id
      // deviceId: "", //当前塔吊deviceId
      towerlist: [], //塔吊设备列表
      allPart: {}, //当前塔吊信息
      // showUrl: "", //地址
      ulLeft:'0vw',
      //监控数据
      ysToken:'',//萤石云token
      serial:'',
      channel:'',
      type:'',
      player:null,
      //开始时间
      starttime:'',
      endtime:'',
      //时间快捷键
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
          const date = new Date();
          date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      //弹出框
      videoDialog:false,
      //视频列表
      gridData:[],
      //时间范围快捷键
      pickerOptionsRange:{
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
          }
        }]
      },
      timeRange:[],//时间范围
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      //判断是否开启对接
      isTalk:false,
      //判断是否录像
      isLu:false,
      recTime:0,//录像时间
      luDing:undefined,
      //云录像设置
      setDialog:false,
      setForm:{
        deviceSerial:'',
        channelNo:'',
        projectId:'',
        startTime:'',
        endTime:''
      },
      rules:{
        startTime:[{ required: true, message: '请选择日期时间', trigger: 'change'}],
        endTime:[{ required: true, message: '请选择日期时间', trigger: 'change'}]
      },
      pickerOptions1:{
        disabledDate(time) {
          //此条为设置禁止用户选择今天之前的日期，包含今天。
          return time.getTime() >= (Date.now());
          //此条为设置禁止用户选择今天之前的日期，不包含今天。
          // return time.getTime() > (Date.now()-(24 * 60 * 60 * 1000));
        }
      }
    };
  },
  mounted() {
    this.groupId = util.session.get("groupId");
    this.getTowerList();
  },
  destroyed: function() {},
  methods: {
    //获取塔吊设备
    getTowerList() {
      var that = this;
      myHttp.getTowerListByPage({
        projectId: this.groupId,
      }).then(function(resp) {
        if (resp.data.code == "200") {
          var list = resp.data.data.towerList || [];
          for (var i = 0; i < list.length; i++) {
            if (list[i].machType == "3") {
              list[i].online =
                list[i].connectedStatus && "" != list[i].connectedStatus
                  ? list[i].connectedStatus
                  : "离线";
            } else {
              if (list[i].status == "0") {
                list[i].online = "离线";
              } else if (list[i].status == "1") {
                list[i].online = "在线";
              } else {
                list[i].online = "异常";
              }
            }
          }
          that.towerlist = list;
          if (list.length > 0 && that.towerId == "") {
            that.towerId = list[0].id;
            // that.deviceId = list[0].deviceId;
            if(list[0].camera){
              that.shwoVideo(list[0].camera)
            }
          }
          // if (that.towerId != "") {
          //   that.getRealInfo();
          // }
        }
      });
    },
    //渲染监控
    shwoVideo(obj){
      this.serial = obj.serial
      this.channel = obj.channelNo
      this.type = obj.type
      this.getYsToken()
    },
    //获取token
    getYsToken(){
      var that = this
      myHttp.getYsToken({
        projectId: this.groupId
      }).then(function(resp){
        if(resp.data.code=='200'){
            that.ysToken = resp.data.data.accessToken||''
            that.showVideo()
        }
      })
    },
    //展示监控   
    showVideo(){
      var ezurl = "ezopen://open.ys7.com/"+this.serial+"/"+this.channel+".hd.live";
      this.player = new EZUIKit.EZUIKitPlayer({
        // autoplay: true, //自动播放
          id: 'video-container', // 视频容器ID
          accessToken: this.ysToken,
          url: ezurl,
          plugin:['talk'],
          handleSuccess:function(){
              console.log('播放成功')
          },
          handleError:function(e){
              console.log('播放失败：')
              console.error(e)
          },
          openSoundCallBack:function(e){
              console.log('声音开启：')
              console.log(e)
          },
          closeSoundCallBack:function(e){
              console.log('声音关闭：')
              console.log(e)
          },
          startSaveCallBack(e){
              console.log('开启本地录像：')
              console.log(e)
          },
          stopSaveCallBack(e){
              console.log('结束本地录像：')
              console.log(e)
          },
      })
    },
    //回看
    clickRecordSearch(){
      this.player.stop();
      document.getElementById('video-container').innerHTML=''
      if((!this.starttime || this.starttime=='')&&(!this.endtime||this.endtime=='')){
          this.showVideo()
      }else{
          var ezurl = "ezopen://open.ys7.com/"+this.serial+"/"+this.channel+".hd.rec?begin="+this.starttime+"&end="+this.endtime;
          this.player = new EZUIKit.EZUIKitPlayer({
              id: 'video-container', // 视频容器ID
              accessToken: this.ysToken,
              url: ezurl,
          })
      }
    },
    //云台控制
    startYunCtrl(index){
      myHttp.ptzController({
          projectId: this.groupId,
          deviceSerial:this.serial,
          channelNo:this.channel,
          direction:index,
          flag:1
      }).then(resp=>{
          console.log('操作成功')
      },error=>{
          console.error(error.data.msg)
      })
    },
    stopYunCtrl(index){
      myHttp.ptzController({
          projectId: this.groupId,
          deviceSerial:this.serial,
          channelNo:this.channel,
          direction:index,
          flag:2
      }).then(resp=>{
          console.log('操作成功')
      },error=>{
          console.error(error.data.msg)
      })
    },

    //开启声音
    startVoice(){
      this.player.openSound()
    },
    //关闭声音
    stopVoice(){
      this.player.closeSound()
    },
    //截图
    capturePicture(){
      this.player.capturePicture()
    },
    //打开对讲机
    startTalk(){
      this.isTalk = true
      this.player.startTalk()
    },
    //关闭对讲机
    stopTalk(){
      this.isTalk = false
      this.player.stopTalk()
    },
    // getRealInfo() {
    //   var that = this;
    //   myHttp.getTowerInfoByPage({
    //     id: this.towerId,
    //     v: new Date().getTime(),
    //   }).then(function(resp) {
    //     if (resp.data.code == "200") {
    //       var data = resp.data.data.tower || {};
    //       data.angle = data.angle && "" != data.angle ? data.angle : 0;
    //       that.allPart = data;
    //       for (var i in that.valData) {
    //         that.valData[i] = data[i] || 0;
    //       }
    //       that.cameraData = data.camera || {};
    //       if (data.camera) {
    //         that.getVideo(data.camera.serial, data.camera.channelNo);
    //       }
    //     }
    //   });
    // },
    //获取监控视频
    // getVideo(serial, channel) {
    //   var that = this;
    //   myHttp.getYsToken().then(function(resp) {
    //     if (resp.data.code == "200") {
    //       var ysToken = resp.data.data.accessToken || "";
    //       that.showUrl =
    //         "/monitor/view/one.html?serial=" +
    //         serial +
    //         "&channel=" +
    //         channel +
    //         "&token=" +
    //         ysToken;
    //     }
    //   });
    // },
    /**
     * 历史监控列表
     */
    getVideList(){
      this.videoDialog = true
      this.getVideoList()
    },
    //查询监控
    doFilter(){
        // console.log(this.timeRange)
        this.getVideoList()
    },
    //获取视频列表
    getVideoList(){
      myHttp.getVideoFilePage({
        projectId:'001',//util.session.get('groupId'),
        pageNumber:0,
        pageSize:20,
        startTime:this.timeRange.length>0?this.timeRange[0]:'',
        endTime:this.timeRange.length>0?this.timeRange[1]:''
      }).then(resp=>{
        if(resp.data.code==200){
          var list = resp.data.data.list||[]
          for(var i=0;i<list.length;i++){
            list[i].fileSize = util.common.conver(list[i].fileSize)
            list[i].duration = util.common.s_to_hs(list[i].duration)
            list[i].createTime = util.myTime.formatTime(list[i].createTime,'YYYY-MM-dd HH:mm:ss')
          }
          this.gridData = list
        }
      },error=>{

      })
    },

    //下载
    dowLoad(row){
      myHttp.getDownloadUrl({
        projectId:'001',
        fileId:row.fileId
      }).then(resp=>{
        if(resp.data.code==200){
          var url = resp.data.data.url
          if(url.indexOf(',')>0){
            var urls = url.split(',')
            for(var i=0;i<urls.length;i++){
              if(urls[i].indexOf('https')>-1){
                window.open(urls[i])
              }else{
                var str = urls[i].replace('http','https')
                window.open(str)
              }
            }
          }else{
              if(url.indexOf('https')>-1){
                window.open(url)
              }else{
                var str = url.replace('http','https')
                window.open(str)
              }
          }
        }else{
          this.$message.error(resp.data.msg)
        }
      })
    },
    //本地录像 -开始
    startLu(){
        this.isLu = true
        this.player.startSave()
        this.recTime = 0
        this.luDing = window.setInterval(()=>{
            this.recTime ++
        },1000)
    },
    //本地录像 -结束
    stopLu(){
        this.isLu = false
        this.player.stopSave();
        window.clearInterval(this.luDing)
    },
    //时间转换
    transTime(val){
        return util.common.s_to_hs(val)
    },
    //设置云录像时间
    setYunRecTime(){
        this.setDialog = true
        this.setForm.deviceSerial = this.serial
        this.setForm.channelNo = this.channel
        this.setForm.projectId = '001'//this.groupId
        this.setForm.startTime = ''
        this.setForm.endTime = ''
    },
    //提交时间
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          myHttp.getPlaybackVideo(this.setForm).then(resp=>{
            if(resp.data.code==200){
              this.$message.success('设置成功')
              this.setDialog = false
            }else{
              this.$message.error(resp.data.msg)
            }
          })
        } else {
          return false;
        }
      });
    },
    //重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //选择塔吊
    changeTower(obj) {
      this.towerId = obj.id;
      this.serial = obj.serial
      this.channel = obj.channelNo
      this.type = obj.type
      this.player.stop();
      if(obj.camera){
        document.getElementById('video-container').innerHTML=''
        this.shwoVideo(obj.camera)
      }
    },
    /**
     * 
     */
    toLeft(){
      var index = this.getIndex()
      console.log(index)
      if(index>0){
        index--
        this.changeTower(this.towerlist[index])
      }
      if(index>3){
        var l = 14*(index-3)
        this.ulLeft = '-'+l+'vw'
      }else{
        this.ulLeft = '0vw'
      }
    },
    toRight(){
      var index = this.getIndex()
      if(index<this.towerlist.length){
        index++
        this.changeTower(this.towerlist[index])
      }
      if(index>3){
        var l = 14*(index-3)
        this.ulLeft = '-'+l+'vw'
      }else{
        this.ulLeft = '0vw'
      }
    },
    //获取当前塔吊下标
    getIndex(){
      var index = 0
      for(var i=0;i<this.towerlist.length;i++){
        if(this.towerId == this.towerlist[i].id){
          index = i
        }
      }
      return index
    },
  },

  destroyed(){
    this.player.stop();
  },
};
</script>
<style scoped>
  .box-main{
    width: 100%;
    height: calc( 100% - 4vh );
    position: relative;
    padding: 0 1vw;
  }
  .monitor-list{
    width: 100%;
    height: 10vh;
    position: relative;
    display: flex;
  }
  .monitor-list .item-icon{
    width: 1.5vw;
    height: 100%;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .list-ul{
    width: calc( 100% - 3vw );
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .list-item{
    width: 13vw;
    height: 100%;
    position: relative;
    background: #fff;
    margin-right: 1vw;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    padding: 1vh;
    float: left;
    cursor: pointer;
  }
  .list-item .name{
    width: 9vw;
    height: 4vh;
    position: relative;
    font-size: 1vw;
    line-height: 4vh;
    font-weight: bold;
    text-align: left;
  }
  .list-item .stu{
    width: 2.5vw;
    height: 4vh;
    position: relative;
    display: flex;
    align-items: center;
    text-align: right;
  }
  .list-item .code{
    width: 100%;
    height: 4vh;
    position: relative;
    display: flex;
    align-items: center;
    font-size: 0.8vw;
  }
  .box-monitor{
    width: 100%;
    height: calc( 100% - 10vh );
    position: relative;

  }
  ::-webkit-scrollbar{
    height: 0;
  }
  /***
   * 监控css
   */
  .box-contain{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    padding: 0.5vh;
    overflow: auto;
    align-content: flex-start;
  }
  .box-video{
    width: 80%;
    height: 100%;
    position: relative;
    background: #000;
  }
  .box-right{
    width: 20%;
    height: 100%;
    position: relative;
    background: #E7F1FB;
    padding-left: 0.5vw;
  }
  .item_title{
    font-size: 18px;
    padding: 10px;
    background: #fff;
    border-left: 0.1rem solid #E7F1FB;
  }
  .item_content{
    flex-wrap: wrap;
    padding: 0.1rem 0.1rem 0.1rem 0.1rem;
    height: calc( 100% - 50px );
    overflow: auto;
  }
  .itemR_first,.itemR_second{
    background: #fff;
    width: 100%;
    padding: 1vh;
    margin-bottom: 10px;
  }
  .itemR_first_t,.itemR_second_t{
    height: 3vh;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .itemR_first_t div,.itemR_second_t div{
    width: 30%;
    height: 2px;
    margin-top: 10px;
  }
  .itemR_first_t span,.itemR_second_t span{
    padding: 0 20px;
    font-size: 18px;
  }
  .itemR_first_t div.l_left,.itemR_second_t div.l_left{
    background: linear-gradient(to right, rgba(79, 163, 241,0) , rgba(79, 163, 241,1));
  }
  .itemR_first_t div.l_right,.itemR_second_t div.l_right{
    background: linear-gradient(to left, rgba(79, 163, 241,0) , rgba(79, 163, 241,1));
  }
  .itemR_first_n_name{
    display: inline-block;
    width: 6vw;
    text-align: right;
  }
  .itemR_first_n_val{
    height: 3vh;
    border:1px solid #ddd;
    padding: 0 0.5vh;
  }
  .itemR_first_n{
    margin: 5px;
    display: flex;
    align-content: center;
    align-items: center;
  }
  .layui-btn-container{
    text-align: center;
    margin-top: 20px;
  }
  .cn-wrapper .layui-btn{
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
  }
  .yunCtl{
    display: flex;flex-wrap: wrap;justify-content:space-around;
  }
  .yunCtl-con{
    position: relative;padding: 0 15px;margin-bottom: 20px;display: flex;width: 100%;height: 40px;justify-content: center;align-items: center;
  }
  .yunCtl-con-val{
    flex: 1;text-align: center;font-size: 16px;
  }
  .list-item.on{
    /* border: 1px solid #409EFF; */
    background: rgb(64 158 255 / 36%);
  }
</style>
<style>
  @import '../../assets/css/common.css';
  .videoHead{
    width: 100%;
    height: 6vh;
    position: relative;
    padding: 0 1vw;
    display: flex;
    align-content: center;
    align-items: center;
  }
</style>
